import * as Types from '../generatedTypes';

import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
const defaultOptions = {} as const;
export type GetReportResultLinkMutationVariables = Types.Exact<{
  report_file_key: Types.Scalars['String'];
}>;


export type GetReportResultLinkMutation = { __typename?: 'Mutation', getReportResultLink?: string | null };


export const GetReportResultLinkDocument = gql`
    mutation getReportResultLink($report_file_key: String!) {
  getReportResultLink(report_file_key: $report_file_key)
}
    `;
export type GetReportResultLinkMutationFn = Apollo.MutationFunction<GetReportResultLinkMutation, GetReportResultLinkMutationVariables>;

/**
 * __useGetReportResultLinkMutation__
 *
 * To run a mutation, you first call `useGetReportResultLinkMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useGetReportResultLinkMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [getReportResultLinkMutation, { data, loading, error }] = useGetReportResultLinkMutation({
 *   variables: {
 *      report_file_key: // value for 'report_file_key'
 *   },
 * });
 */
export function useGetReportResultLinkMutation(baseOptions?: Apollo.MutationHookOptions<GetReportResultLinkMutation, GetReportResultLinkMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<GetReportResultLinkMutation, GetReportResultLinkMutationVariables>(GetReportResultLinkDocument, options);
      }
export type GetReportResultLinkMutationHookResult = ReturnType<typeof useGetReportResultLinkMutation>;
export type GetReportResultLinkMutationResult = Apollo.MutationResult<GetReportResultLinkMutation>;
export type GetReportResultLinkMutationOptions = Apollo.BaseMutationOptions<GetReportResultLinkMutation, GetReportResultLinkMutationVariables>;